import { DialogCancelableOperationResult, DialogOpenResult, DialogService } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { AlertDialog, AlertOptions } from './alert-dialog';
import { ConfirmDialog, ConfirmOptions } from './confirm-dialog';
import { ErrorDialog, ErrorOptions } from './error-dialog';

@autoinject
export class DialogHelper {
  constructor(private dialogService: DialogService) { }

  async open<TModel, TOutput>(viewModel?: string | { new(...params: unknown[]): object } | object, model?: TModel, opened?: (controller: DialogOpenResult) => void): Promise<DialogCloseResult<TOutput>> {
    const dialogOpenResult = await this.dialogService.open({ viewModel: viewModel, model: model }) as DialogOpenResult;
    if (dialogOpenResult.wasCancelled) return dialogOpenResult;
    if (opened) opened(dialogOpenResult);
    return dialogOpenResult.closeResult;
  }

  async alert(message: string, dialogTitle?: string): Promise<void>;
  async alert(options: AlertOptions, opened?: (result: DialogOpenResult) => void): Promise<void>
  async alert(optionsOrMessage: AlertOptions | string): Promise<void> {
    const options = { class: '--info', ...(typeof optionsOrMessage === 'string' ? { message: optionsOrMessage } : optionsOrMessage) };
    await this.open(AlertDialog, typeof arguments[1] === 'string' ? { ...options, dialogTitle: arguments[1] } : options, typeof arguments[1] === 'function' ? arguments[1] : undefined);
  }

  async confirm(message: string, dialogTitle?: string): Promise<boolean>;
  async confirm(options: ConfirmOptions, opened?: (result: DialogOpenResult) => void): Promise<boolean>;
  async confirm(optionsOrMessage: ConfirmOptions | string): Promise<boolean> {
    const options = { class: '--warning', ...(typeof optionsOrMessage === 'string' ? { message: optionsOrMessage } : optionsOrMessage) };
    return !(await this.open(ConfirmDialog, typeof arguments[1] === 'string' ? { ...options, dialogTitle: arguments[1] } : options, typeof arguments[1] === 'function' ? arguments[1] : undefined)).wasCancelled;
  }

  async error(message: string, dialogTitle?: string): Promise<void>;
  async error(options: ErrorOptions, opened?: (result: DialogOpenResult) => void): Promise<void>
  async error(optionsOrMessage: ErrorOptions | string): Promise<void> {
    const options = { class: '--danger', ...(typeof optionsOrMessage === 'string' ? { message: optionsOrMessage } : optionsOrMessage) };
    await this.open(ErrorDialog, typeof arguments[1] === 'string' ? { ...options, dialogTitle: arguments[1] } : options, typeof arguments[1] === 'function' ? arguments[1] : undefined);
  }
}

export interface DialogCloseResult<TOutput> extends DialogCancelableOperationResult {
  output?: TOutput;
}
